import React, { useEffect, useState } from 'react';
import {
  MinusIcon,
  MoreIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import { navigate } from 'gatsby';
import {
  ActionButtonStyled,
  CDAContainerStyled,
  CDAContentStyled,
  CDAHeaderStyled,
  SkeletonTitle,
  SkeletonSubtitle,
  SkeletonActionButton,
  SkeletonCDAContainer,
  SkeletonMoreText,
  SkeletonMoreIcon,
  SeeMoreButtonStyled,
} from './styles/CDAStyled';

import CDAService from '../../../services/CDA';

const CDA = () => {
  const [actionButtons, setActionButtons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showHiddenButtons, setShowHiddenButtons] = useState(false);
  const [error, setError] = useState(false);
  const maxSlice = !showHiddenButtons ? 3 : actionButtons.length;

  const showCDAIframe = (title, iframe, height) => {
    const urlToRedirect = `${title
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ /g, '-')
      .toLowerCase()}`;
    navigate(`/ayuda/centro-de-ayuda/${urlToRedirect}`, {
      state: { iframe, title, height },
    });
  };

  useEffect(() => {
    CDAService.getCDA()
      .then(([{ cda }]) => {
        setActionButtons(cda);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, []);

  if (loading)
    return (
      <CDAContainerStyled>
        <CDAHeaderStyled>
          <SkeletonTitle />
          <SkeletonSubtitle />
        </CDAHeaderStyled>
        <CDAContentStyled>
          <SkeletonActionButton />
          <SkeletonActionButton />
          <SkeletonActionButton />
        </CDAContentStyled>
        <SkeletonCDAContainer>
          <SkeletonMoreText />
          <SkeletonMoreIcon />
        </SkeletonCDAContainer>
      </CDAContainerStyled>
    );

  if (error || actionButtons.length === 0) return null;

  return (
    <CDAContainerStyled>
      <CDAHeaderStyled>
        <h1>Centro de ayuda</h1>
        <h2>Encuentra tus preguntas por tema</h2>
      </CDAHeaderStyled>
      <CDAContentStyled>
        {actionButtons.slice(0, maxSlice).map((actionButton, index) => (
          <ActionButtonStyled
            upperTitle={actionButton.title}
            key={actionButton.title}
            icon={() => (
              <img src={actionButton.icon.url} alt={actionButton.title} />
            )}
            centerbutton={
              index + 1 === actionButtons.length && index % 3 === 0 ? 1 : 0
            }
            onClick={() => {
              showCDAIframe(
                actionButton.title,
                actionButton.iframe,
                actionButton.height
              );
            }}
          />
        ))}
      </CDAContentStyled>
      {actionButtons.length > 3 && (
        <SeeMoreButtonStyled
          onClick={() => setShowHiddenButtons(!showHiddenButtons)}
        >
          {!showHiddenButtons ? (
            <>
              VER MÁS <MoreIcon />
            </>
          ) : (
            <>
              OCULTAR <MinusIcon />
            </>
          )}
        </SeeMoreButtonStyled>
      )}
    </CDAContainerStyled>
  );
};

export default CDA;
